export const USER_EMAIL_STORAGE_KEY = 'matevolno.userEmail.v1'

const RESERVATION_PROFILE_STORAGE_KEY = 'matevolno.reservation.userProfile.v1'
const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

function normalizeEmail(value: unknown): string {
  if (typeof value !== 'string') return ''

  const email = value.trim()
  return EMAIL_PATTERN.test(email) ? email : ''
}

export function loadStoredEmail(): string {
  if (typeof window === 'undefined') return ''

  try {
    const email = normalizeEmail(window.localStorage.getItem(USER_EMAIL_STORAGE_KEY))
    if (email) return email

    const reservationProfile = window.localStorage.getItem(RESERVATION_PROFILE_STORAGE_KEY)
    if (!reservationProfile) return ''

    const parsedProfile = JSON.parse(reservationProfile) as unknown
    if (!parsedProfile || typeof parsedProfile !== 'object') return ''

    return normalizeEmail((parsedProfile as Record<string, unknown>).email)
  } catch {
    return ''
  }
}

export function saveStoredEmail(value: string): void {
  if (typeof window === 'undefined') return

  const email = normalizeEmail(value)
  if (!email) return

  try {
    window.localStorage.setItem(USER_EMAIL_STORAGE_KEY, email)
  } catch {
    // Ignore private mode / quota / disabled storage.
  }
}
